<div class="content">

    <div class="text-left mt-5">


        <h3>Create or Register Webhook</h3> <br><br>
  
        <p>Create a webhook</p><br>
  
        <p><a class="text-muted">REQUEST BODY SCHEMA:</a> application/json</p>
        <hr><br>
  
        <p><b>A webhook request object</b></p><br>


        <div class="table-responsive">
            <table class="table table-primary table-bordered">
                <tbody>
    
                    <tr>
                        <td>
                            <h6>url</h6>
                        </td>
                        <td colspan="4">
                            <small>string</small>
                            <p>
                                [Mandatory] Webhook URL
                            </p>
                        </td>
                    </tr>
    
                </tbody>
            </table>
          </div><br>


          <div class="card text-bg-dark mb-3">
            <div class="card-body">
                <pre><button type="button" class="btn btn-success">POST</button>  https://api.optimusdrive.ai/v1/customer/webhook</pre>
            </div>
        </div> <br><br>


        <h5>Example Request</h5><br>

        <div class="card text-bg-dark mb-3">
            <div class="card-body">
    
                <div class="card-title">
                    <button style="float: right;" *ngIf="copyButton" class="btn btn-outline-primary btn-sm" (click)="copyJsonToClipboard()">
                      <i class="fa fa-clipboard" aria-hidden="true"></i>
                    </button>
                      
                    <button style="float: right;" *ngIf="copiedButton"  class="btn btn-success btn-sm">
                      Copied <i class="fa fa-check" aria-hidden="true"></i>
                    </button>
              
                   </div><br><br>
                   
                <pre><code [innerHTML]="requestData"></code></pre>
            </div>
        </div><br><br>


        <div>

            <h5>Example Response</h5><br>
    
    
            <div class="card text-bg-light mb-3">
                <div class="card-body">
    
                    <div class="panel panel-primary">
                        <div class="tab-menu-heading">
                            <ul class="nav nav-pills" role="tablist">
                                <!-- Tab menu items -->
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="tab1" data-bs-toggle="tab"
                                        data-bs-target="#content1" type="button" role="tab" aria-controls="content1"
                                        aria-selected="true">200</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="tab2" data-bs-toggle="tab" data-bs-target="#content2"
                                        type="button" role="tab" aria-controls="content2"
                                        aria-selected="false">401</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="tab3" data-bs-toggle="tab" data-bs-target="#tent3"
                                        type="button" role="tab" aria-controls="content3"
                                        aria-selected="false">417</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="tab4" data-bs-toggle="tab" data-bs-target="#content4"
                                        type="button" role="tab" aria-controls="content4"
                                        aria-selected="false">500</button>
                                </li>
                            </ul>
                        </div>
    
                        <div class="panel-body tabs-menu-body mt-4">
                            <div class="tab-content">
                                <!-- Tab content -->
                                <div class="tab-pane fade show active" id="content1" role="tabpanel"
                                    aria-labelledby="tab1">
                                    <div class="card-body">
                                        <pre><code [innerHTML]="sucessData" ></code></pre>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="content2" role="tabpanel" aria-labelledby="tab2">
                                    <div class="card-body">
                                        <pre><code [innerHTML]="Error4x" ></code></pre>
                                    </div>
                                </div>
    
                                <div class="tab-pane fade" id="tent3" role="tabpanel" aria-labelledby="tab3">
    
                                    <div class="card-body" id="content3">
                                        <pre><code [innerHTML]="Error5x" ></code></pre>
                                    </div><br>
    
                                </div>
    
    
                                <div class="tab-pane fade" id="content4" role="tabpanel" aria-labelledby="tab4">
                                    <div class="card-body">
                                        <pre><code [innerHTML]="example500" ></code></pre>
                                    </div>
                                </div>
    
                            </div>
                        </div>
                    </div>
    
                </div>
            </div>
    
    
        </div><br><br><br>


        <h3>List Webhooks</h3> <br><br><br>

        <p>Lists all the webhook belonging to the customer</p><br><br>
    
    
        <div class="card text-bg-dark mb-3">
            <div class="card-body">
                <pre><button type="button" class="btn btn-success">GET</button>  https://api.optimusdrive.ai/v1/customer/webhook</pre>
            </div>
        </div> <br><br>


        <h5>Example Request</h5><br>

        <div class="card text-bg-dark mb-3">
            <div class="card-body">
    
                <div class="card-title">
                    <button style="float: right;" *ngIf="copyButton1" class="btn btn-outline-primary btn-sm" (click)="copyJsonToClipboard1()">
                      <i class="fa fa-clipboard" aria-hidden="true"></i>
                    </button>
                      
                    <button style="float: right;" *ngIf="copiedButton1"  class="btn btn-success btn-sm">
                      Copied <i class="fa fa-check" aria-hidden="true"></i>
                    </button>
              
                   </div><br><br>
                   
                <pre><code [innerHTML]="requestData1"></code></pre>
            </div>
        </div><br><br>


        
        
        <div>

            <h5>Example Response</h5><br>
    
    
            <div class="card text-bg-light mb-3">
                <div class="card-body">
    
                    <div class="panel panel-primary">
                        <div class="tab-menu-heading">
                            <ul class="nav nav-pills" role="tablist">
                                <!-- Tab menu items -->
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="tab1" data-bs-toggle="tab"
                                        data-bs-target="#response1" type="button" role="tab" aria-controls="response1"
                                        aria-selected="true">200</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="tab2" data-bs-toggle="tab" data-bs-target="#response2"
                                        type="button" role="tab" aria-controls="response2"
                                        aria-selected="false">401</button>
                                </li>
    
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="tab4" data-bs-toggle="tab" data-bs-target="#response4"
                                        type="button" role="tab" aria-controls="response4"
                                        aria-selected="false">500</button>
                                </li>
                            </ul>
                        </div>
    
                        <div class="panel-body tabs-menu-body mt-4">
                            <div class="tab-content">
                                <!-- Tab content -->
                                <div class="tab-pane fade show active" id="response1" role="tabpanel"
                                    aria-labelledby="tab1">
                                    <div class="card-body">
                                        <pre><code [innerHTML]="sucessData1" ></code></pre>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="response2" role="tabpanel" aria-labelledby="tab2">
                                    <div class="card-body">
                                        <pre><code [innerHTML]="Error4x1" ></code></pre>
                                    </div>
                                </div>
    
                                <div class="tab-pane fade" id="response4" role="tabpanel" aria-labelledby="tab4">
                                    <div class="card-body">
                                        <pre><code [innerHTML]="example500" ></code></pre>
                                    </div>
                                </div>
    
                            </div>
                        </div>
                    </div>
    
                </div>
            </div>
    
    
        </div><br><br><br>



        <h3>Delete Webhook</h3> <br><br><br>

        <p>Delete Webhook belonging to the customer</p><br><br>
    
        <p>PATH PARAMETERS</p>
        <hr><br>
    
        <p><b>Batch Request Body</b></p><br>


        <div class="table-responsive">
            <table class="table table-primary table-bordered">
                <tbody>
      
                    <tr>
                        <td>
                            <h6>id [required]</h6>
                        </td>
                        <td colspan="4">
                            <small>string^[-a-z0-9_]+$</small>
                            <p>
                                The webhook id of the webhook to delete
                            </p>
                        </td>
                    </tr>
      
                </tbody>
            </table>
        </div><br>

        <div class="card text-bg-dark mb-3">
            <div class="card-body">
                <pre><button type="button" class="btn btn-success">DELETE</button>  https://api.optimusdrive.ai/v1/customer/webhook/&#123;id&#125;</pre>
            </div>
        </div> <br><br>



        <h5>Example Request</h5><br>

        <div class="card text-bg-dark mb-3">
            <div class="card-body">
      
                <div class="card-title">
                    <button style="float: right;" *ngIf="copyButton2" class="btn btn-outline-primary btn-sm" (click)="copyJsonToClipboard2()">
                      <i class="fa fa-clipboard" aria-hidden="true"></i>
                    </button>
                      
                    <button style="float: right;" *ngIf="copiedButton2"  class="btn btn-success btn-sm">
                      Copied <i class="fa fa-check" aria-hidden="true"></i>
                    </button>
              
                   </div><br><br>
                   
                <pre><code [innerHTML]="requestData2"></code></pre>
            </div>
        </div><br><br>



        <div>

            <h5>Example Response</h5><br>
    
    
            <div class="card text-bg-light mb-3">
                <div class="card-body">
    
                    <div class="panel panel-primary">
                        <div class="tab-menu-heading">
                            <ul class="nav nav-pills" role="tablist">
                                <!-- Tab menu items -->
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="tab1" data-bs-toggle="tab"
                                        data-bs-target="#tent1" type="button" role="tab" aria-controls="tent1"
                                        aria-selected="true">200</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="tab2" data-bs-toggle="tab" data-bs-target="#tent2"
                                        type="button" role="tab" aria-controls="tent2"
                                        aria-selected="false">400</button>
                                </li>
    
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="tab4" data-bs-toggle="tab" data-bs-target="#tent4"
                                        type="button" role="tab" aria-controls="tent4"
                                        aria-selected="false">401</button>
                                </li>

                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="tab4" data-bs-toggle="tab" data-bs-target="#tent5"
                                        type="button" role="tab" aria-controls="tent4"
                                        aria-selected="false">500</button>
                                </li>

                            </ul>
                        </div>
    
                        <div class="panel-body tabs-menu-body mt-4">
                            <div class="tab-content">
                                <!-- Tab content -->
                                <div class="tab-pane fade show active" id="tent1" role="tabpanel"
                                    aria-labelledby="tab1">
                                    <div class="card-body">
                                        <pre><code [innerHTML]="sucessData2" ></code></pre>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="tent2" role="tabpanel" aria-labelledby="tab2">
                                    <div class="card-body">
                                        <pre><code [innerHTML]="example400" ></code></pre>
                                    </div>
                                </div>

                                <div class="tab-pane fade" id="tent4" role="tabpanel" aria-labelledby="tab4">
                                    <div class="card-body">
                                        <pre><code [innerHTML]="Error4x" ></code></pre>
                                    </div>
                                </div>
    
                                <div class="tab-pane fade" id="tent5" role="tabpanel" aria-labelledby="tab5">
                                    <div class="card-body">
                                        <pre><code [innerHTML]="example500" ></code></pre>
                                    </div>
                                </div>
    
                            </div>
                        </div>
                    </div>
    
                </div>
            </div>
    
    
        </div><br><br><br>

        


        <h3>Examples of Status Messages on Webhook</h3> <br><br>


        <h5>PENDING</h5><br>

        <div class="card text-bg-light mb-3">
            <div class="card-body">
                <pre><code [innerHTML]="pending"></code></pre>
            </div>
        </div><br><br>


        <h5>PREPROCESSING</h5><br>

        <div class="card text-bg-light mb-3">
            <div class="card-body">
                <pre><code [innerHTML]="preprocessing"></code></pre>
            </div>
        </div><br><br>


        <h5>TRANSCODING</h5><br>

        <div class="card text-bg-light mb-3">
            <div class="card-body">
                <pre><code [innerHTML]="transcoding"></code></pre>
            </div>
        </div><br><br>


        <h5>COMPLETED</h5><br>

        <div class="card text-bg-light mb-3">
            <div class="card-body">
                <pre><code [innerHTML]="complete"></code></pre>
            </div>
        </div><br><br>







  






















        
    </div>

</div>